// extracted by mini-css-extract-plugin
export default {"container":"user-profile_container__jHYnK"};